import React from 'react';

interface CloseProps {
    fill?: string;
    width: number;
    height: number;
}

export const Close = ({ fill = 'currentColor', width = 12, height = 12 }: CloseProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 0.707L11.293 0L6 5.293L0.707 0L0 0.707L5.293 6L0 11.293L0.707 12L6 6.707L11.293 12L12 11.293L6.707 6L12 0.707Z"
            fill={fill}
        />
    </svg>
);
